import React, { useEffect, useState } from 'react';
import './global.css';
import SideBar from './componentes/SideBar';
import HomeView from './views/HomeView';
import PortfolioView from './views/PortfolioView';
import AboutMe from './views/AboutMe';
import ContactMe from './views/modalViews/ContactMe';

const getTheme = () => {
    try {
        return localStorage.getItem('portfolio-theme') === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
};

function App() {
    const [theme, setTheme] = useState(getTheme);

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        try {
            localStorage.setItem('portfolio-theme', theme);
        } catch {
            // The theme still works when browser storage is unavailable.
        }
    }, [theme]);

    return (
        <>
            <a className="skip-link" href="#main">Skip to content</a>
            <SideBar theme={theme} onThemeChange={() => setTheme(theme === 'light' ? 'dark' : 'light')} />
            <main id="main" tabIndex="-1">
                <HomeView />
                <PortfolioView />
                <AboutMe />
                <ContactMe />
            </main>
            <footer className="site-footer container">
                <a className="footer-name" href="#home">Andrew Kasper<span aria-hidden="true"> ↗</span></a>
                <p>Built with care. And React.</p>
                <a href="/data/Andrew-Kasper-Resume.pdf" target="_blank" rel="noreferrer">Résumé <span className="sr-only">(PDF, opens in a new tab)</span><span aria-hidden="true">↗</span></a>
            </footer>
        </>
    );
}

export default App;
